<template lang="pug">
  .select-campaign-category(v-loading="loading")
    el-row
      el-col.required(v-if="showLabel" :span="4") {{ $t('项目类别') }}
      el-col(:span="20")
        el-switch.roster--0(
          v-if="showRoster"
          v-model="roster[0]"
          :disabled="disabled"
          active-text="Roster"
        )
        el-switch.roster--1(
          v-if="showRoster"
          v-model="roster[1]"
          :disabled="disabled"
          active-text="Roster"
        )
        el-switch.roster--3(
          v-if="showRoster"
          v-model="roster[2]"
          :disabled="disabled"
          active-text="Roster"
        )
        el-checkbox-group.checkbox-group(
          :disabled="disabled"
          v-model="checkedCategories"
          @change="handleCategoryChange"
        )
          .checkbox-group-item(
            v-for="item, i in categories"
          )
            el-checkbox(
              :label="item.category_id"
              :style="{marginBottom: showRoster && [0, 1].includes(i) ? '25px' : '15px'}"
              :disabled="getCategoryShouldDisabled(item.category_id)"
            )
              span {{ item.category_name }}
              el-tooltip(
                :content="$t(item.introduction_ch)"
                placement="top"
                v-if="item.category_id !== 13"
                :style="{ marginLeft: '5px' }"
              )
                i.el-icon-question
            .sub-checkbox-group-container(
              v-if="checkedCategories.includes(item.category_id) && item.children.length !== 0"
            )
              span(style="margin: 0 10px; font-size: 12px;word-break: keep-all" :class="{disabled: disabled}") {{ $t('Scope') }}:
              el-checkbox-group.sub-checkbox-group(
                v-model="checkedScopes[item.category_id]"
                :disabled="disabled"
                @change="handleScopeChange"
              )
                el-checkbox(
                  v-for="item in item.children"
                  :key="item.scope_id"
                  :label="item.scope_id"
                  :disabled="getScopeShouldDisabled(item)"
                ) {{ item.scope_name }}
</template>

<script>
import axios from 'axios'
import { groupBy, flatten } from 'lodash'
import db from '@/umcc/db'

// const IT_ID = 5 // it的category id
const EVENTS_ID = 13

export default {
  props: {
    disabledBaseIT: {
      type: Boolean,
      default () {
        return false
      }
    },
    needDisabledEvents: {
      type: Boolean,
      default () {
        return false
      }
    },
    value: {
      /**
       * [
       *  {
       *    category_id: 1,
       *    scope_id: 2,
       *  },
       *  {
       *    category_id: 1,
       *    scope_id: 3,
       *  }
       * ]
       */
      type: Array,
      isRequired: true
    },
    propCategories: {
      type: Array,
      isRequired: false,
      default () {
        return null
      }
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showRoster: {
      type: Boolean,
      default: false
    },
    roster: {
      type: Array,
      default () {
        return [false, false]
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    selectedScope: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      /**
       * {
       *  1: [3, 4]
       * }
       * key是选中的category id, value是对应的scopes id
       */
      id: this.mapValueToId(this.value),
      categories: [],
      checkedCategories: [],
      checkedScopes: {},
      loading: true,
      disabledEvents: false
    }
  },
  computed: {
    eventsShouldDisabled () {
      return (this.checkedCategories.length && !this.checkedCategories.includes(EVENTS_ID)) || this.selectedScope.find(item => item.category_id === EVENTS_ID)
    },
    isZh () {
      return db.lang === 'zh'
    }
  },
  watch: {
    value () {
      this.id = this.mapValueToId(this.value)
      this.checkedCategories = Object.keys(this.id).map(Number)
      this.checkedScopes = this.categories.reduce((pre, cur) => {
        pre[cur.category_id] = this.id[cur.category_id] || []
        return pre
      }, {})
    }
  },
  async mounted () {
    this.categories = this.propCategories == null ? await this.fetchCampaignCategries() : this.propCategories
    // this.id = this.mapValueToId(this.value)
    this.checkedCategories = Object.keys(this.id).map(Number)
    if (this.checkedCategories.includes(EVENTS_ID) && this.needDisabledEvents) this.disabledEvents = true
    this.checkedScopes = this.categories.reduce((pre, cur) => {
      pre[cur.category_id] = this.id[cur.category_id] || []
      return pre
    }, {})
    this.loading = false
  },
  methods: {
    getScopeName (item) {
      // if (this.isZh) return item.scope_name_ch + '(' + item.scope_name + ')'
      return item.scope_name
    },
    getCategoryName (item) {
      // if (this.isZh) return item.category_name_ch + '(' + item.category_name + ')'
      return item.category_name
    },
    getCategoryShouldDisabled (id) {
      if (this.type === 'shortcutCategory') {
        return this.checkShouldDisabledCategory(id)
      } else {
        if (!this.needDisabledEvents && this.checkedCategories.length === 0) {
          return false
        } else {
          if (this.needDisabledEvents) {
            if (this.disabledEvents) {
              return true
            } else {
              return id === EVENTS_ID // 之前没有选中events
            }
          } else {
            if (id === EVENTS_ID) {
              return this.eventsShouldDisabled
            } else {
              return !this.eventsShouldDisabled
            }
          }
        }
      }
    },
    checkShouldDisabledCategory (id) {
      const checkedCategories = this.checkedCategories
      if (id === 1) {
        let res = this.selectedScope.find(i => i.category_id === 1)
        if (checkedCategories.length > 0 && !checkedCategories.some(v => v === 1)) {
          return true
        } else {
          return res == null ? false : res.children.length === 7
        }
      }

      if (id === 3) {
        if (this.selectedScope && this.selectedScope.find(i => i.category_id === 3)) {
          return true
        }
        return !checkedCategories.some(v => v === 3) && checkedCategories.length > 0
      }

      if (id === 2) {
        let res = this.selectedScope.find(i => i.category_id === 2)
        if (checkedCategories.length > 0 && !checkedCategories.some(v => v === 2)) {
          return true
        } else {
          return res == null ? false : res.children.length === 3
        }
      }

      if (id === 4) {
        let res = this.selectedScope.find(i => i.category_id === 4)
        if (checkedCategories.length > 0 && !checkedCategories.some(v => v === 4)) {
          return true
        } else {
          return res == null ? false : res.children.length === 3
        }
      }

      if (id === 5) {
        if (this.selectedScope && this.selectedScope.find(i => i.category_id === 5)) {
          return true
        }
        return checkedCategories.length > 0 && !checkedCategories.some(v => v === 5)
      }

      if (id === 13) {
        if (this.selectedScope && this.selectedScope.find(i => i.category_id === 13)) {
          return true
        }
        return checkedCategories.length > 0 && !checkedCategories.some(v => v === 13)
      }
    },
    getScopeShouldDisabled (item) {
      if (this.selectedScope.length === 0) return false
      const res = flatten(this.selectedScope.filter(i => i.category_id === item.category_id)
        .map(res => res.children))
        .map(v => v.scope_id)
      return res.some(i => i === item.scope_id)
    },
    handleScopeChange () {
      this.$emit('change')
      this.$emit('input', this.mapIdToValue())
    },
    handleCategoryChange () {
      this.$emit('changeCategory', this.checkedCategories)
      this.$emit('input', this.mapIdToValue())
    },
    fetchCampaignCategries () {
      return axios.get('/common/getCategoryTreeStructure')
    },
    mapIdToValue () {
      const id = this.checkedCategories.reduce((pre, cur) => {
        pre[cur] = this.checkedScopes[cur].filter(i => i != null)
        return pre
      }, {})
      const value = []
      for (const key in id) {
        if (id[key].length === 0) value.push({ category_id: key })
        id[key].forEach(item => {
          value.push({
            category_id: key,
            scope_id: item
          })
        })
      }
      return value
    },
    mapValueToId (value) {
      const id = groupBy(value, 'category_id')
      for (const key in id) {
        id[key] = id[key].map(item => item.scope_id)
      }
      return id
    }
  }
}
</script>

<style lang="stylus">
.checkbox-group
  display flex
  flex-direction column

.checkbox-group-item
  display flex

.sub-checkbox-group-container
  display flex
  span
    color #606266
  .disabled
    color #c0c4cc

.sub-checkbox-group
  label.el-checkbox
    margin: 0 10px 0 0

.roster--0
  position absolute
  z-index 10
  top 40px
  left 80px

.roster--1
  position absolute
  z-index 10
  top 40%
  left 80px

.roster--3
  position absolute
  z-index 10
  bottom -10px
  left 80px

.select-campaign-category
  .el-switch__label--right
    margin-left -86px
  .el-switch.roster--1.is-disabled .el-switch__label > span
    color #949698
  .el-switch__label
    color #606266
</style>